import { ICommitmentTotalDTO } from '@modules/potential-save-modal/commitment-list/commitment.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class CommitmentListService {
	private readonly _commitmentTotal$: BehaviorSubject<ICommitmentTotalDTO> = new BehaviorSubject<ICommitmentTotalDTO>(
		null,
	);

	public get commitmentTotal$(): Observable<ICommitmentTotalDTO> {
		return this._commitmentTotal$.asObservable().pipe(filter((value) => !!value));
	}

	public updateCommitmentTotal(total: ICommitmentTotalDTO): void {
		this._commitmentTotal$.next(total);
	}
}
